import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {BaseViewElement} from '../base-view-element';
import {PropertySet} from '../../../core/model/helper-models/property-set.model';
import {Property} from '../../../core/model/helper-models/property.model';

@Component({
    selector: 'app-olps-positioning',
    templateUrl: './olps-positioning.component.html',
    styleUrls: ['./olps-positioning.component.scss',
        './../card.scss'],
    standalone: false
})
export class OlpsPositioningComponent extends BaseViewElement implements OnInit, OnChanges
{
    @Input() Position: PropertySet;

    xPosition: Property<any>;
    zPosition: Property<any>;
    currentAxis: Property<any>;
    level: Property<any>;
    liftTop: Property<any>;

    constructor()
    {
        super('olps-positioning');
    }

    onResize(result: any)
    {
        this.childResizeEvent.emit(result);
    }

    ngOnChanges(changes: SimpleChanges): void
    {
        if (this.Position == null)
        {
            this.xPosition = null;
            this.zPosition = null;
            this.currentAxis = null;
            this.level = null;
            this.liftTop = null;
        }
        else
        {
            this.xPosition = this.Position.properties.get('X_AXIS');
            this.zPosition = this.Position.properties.get('Z_AXIS');
            this.currentAxis = this.Position.properties.get('DIRECTION');
            this.level = this.Position.properties.get('LEVEL');
            this.liftTop = this.Position.properties.get('LHD_UP');
        }
    }

}
